import { urlWithParams } from '@marketplace-web/shared/url-util'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const CATALOG_URL = '/catalog'
export const CATALOG_ID_URL = (id: number): string => `/catalog/${id}`
export const ROOT_URL = '/'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const BUYER_PROTECTION_PRO_URL = '/safety_pro#buyer-protection'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale'
